import styled from 'styled-components';
import { Link } from 'gatsby';

import { fonts, colors, metrics } from '@/theme';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const { headerHeight, mobile } = metrics;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${headerHeight.desktop}px;
  background-color: ${colors.white};
  z-index: 100;
  @media (max-width: ${mobile}px) {
    height: ${headerHeight.mobile}px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  margin: auto;
  padding: 20px 85px 0 85px;
  @media (max-width: ${mobile}px) {
    padding: 10px 25px 0 25px;
  }
`;

export const IconWrapper = styled(Link)`
  width: 160px;
  height: 40px;
  padding-top: 8px;
  @media (max-width: ${mobile}px) {
    width: 115px;
    height: 25px;
  }
`;

export const Panel = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  background-color: ${colors.white};
  @media (max-width: ${mobile}px) {
    flex: 1 1 auto;
    justify-content: space-around;
    height: 33px;
    margin: 0 40px 0 25px;
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${colors.black};
  ${fonts.getRegularText()};
  transition: color .5s;
  :hover {
    color: ${colors.blue};
  };
  &:first-child {
    margin-right: 40px;
  }
  opacity: ${() => (typeof window === 'undefined' ? 0 : 1)};
  @media (max-width: ${mobile}px) {
    &:first-child {
      margin-right: 0px;
    }
  }
  @media (max-width: 450px) {
    display: none;
  }
`;

export const LangBox = styled(LanguageSwitcher)`
   margin: 0 120px;
   height: 25px;
   @media (max-width: ${mobile}px) {
    display: none;
  }
`;

export const MenuButton = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  line-height: 1;
  @media (max-width: ${mobile}px) {
    position: absolute;
    top: 16px;
    right: 25px
  }
`;

export const ButtonTitle = styled.div`
  ${fonts.getDesktopFont({})}
  margin-right: 15px;
  user-select: none;
  @media (max-width: ${mobile}px) {
    display: none;
  }
`;
